import {
  BillingPortalSessionResponse,
  BillingSpendResponse,
  BillingTransactionsRequest,
  BillingTransactionsResponse,
  OrderPreviewRequest,
  OrderPreviewResponse,
} from './apiTypes';
import { emptyApiSlice } from './emptyApiSlice';

export const billingApiSlice = emptyApiSlice.injectEndpoints({
  endpoints: builder => ({
    getBillingSpend: builder.query<BillingSpendResponse, void>({
      query: () => ({
        url: '/billing/current-spend',
        method: 'GET',
      }),
      providesTags: ['Billing', 'CurrentSpend'],
    }),
    getOrderPreview: builder.query<OrderPreviewResponse, OrderPreviewRequest>({
      query: body => ({
        url: 'billing/get-order-preview',
        method: 'POST',
        body,
      }),
    }),
    getBillingTransactions: builder.query<
      BillingTransactionsResponse,
      BillingTransactionsRequest
    >({
      query: body => ({
        url: 'billing/get-transactions',
        method: 'POST',
        body,
      }),
      providesTags: ['BillingTransactions'],
    }),
    createBillingPortalSession: builder.mutation<
      BillingPortalSessionResponse,
      void
    >({
      query: () => ({
        url: '/billing/portal-session',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetBillingSpendQuery,
  useGetOrderPreviewQuery,
  useGetBillingTransactionsQuery,
  useCreateBillingPortalSessionMutation,
} = billingApiSlice;
